import { Box, Fade, IconButton, Modal, Typography } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useRef } from "react";
import CreateDebitNote from "../../pages/PrimeFigma/CreateDebitNote";
import { padding } from "@mui/system";

const style = {
  position: "absolute",
  left: "5%",
  right: "5%",
  // transform: 'translate(-50%, -50%)',
  bgcolor: "background.paper",
  boxShadow: 24,
  // p: 4,
  paddingBottom: 2,
  outline: "none",
  // overflow: "scroll",
  height: "93vh",
 
};

function AddPNFDebitNote({ open, setOpen, accountDetails }) {
  const divRef = useRef();
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
      localStorage.removeItem("modalOpen")
    }
  };

  console.log("inside debit note")
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={handleClose}
      ref={divRef}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "5px 15px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                Add Debit Note
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>

          <Box
            className="custom-scrollbar"
            sx={{ overflow: "scroll", height: "80vh" , padding:"10px"}}
          >
            <CreateDebitNote
              isVoucher={handleClose}
              accountDetails={accountDetails}
            />
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default AddPNFDebitNote;
